//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The user model
* 
* @param companyName The company name
* @param mobile The mobile phone number
* @param phone The phone number
* @param vatId The vat id
* @param vatNumber The vat number
* @param website The website
*/
@Serializable

data class CompanyData (


      /* The company name */
    @SerialName(value = "companyName") val companyName: kotlin.String? = null,


      /* The mobile phone number */
    @SerialName(value = "mobile") val mobile: kotlin.String? = null,


      /* The phone number */
    @SerialName(value = "phone") val phone: kotlin.String? = null,


      /* The vat id */
    @SerialName(value = "vatId") val vatId: kotlin.String? = null,


      /* The vat number */
    @SerialName(value = "vatNumber") val vatNumber: kotlin.String? = null,


      /* The website */
    @SerialName(value = "website") val website: kotlin.String? = null


) {




  }

